import { lazyLoad } from "utils/loadable";

const CreateQuestionWithEditor = lazyLoad(
  () => import("./index"),
  (module) => module.default,
  {
    fallback: (
      <div>
        <p>Loading....</p>
      </div>
    ),
  }
);

export default CreateQuestionWithEditor;
